import React from 'react';
import ReactDOM from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import './index.css';
import './i18n';
import App from './App';
import Login from './components/Login';
import SetPassword from './components/SetPassword';
import SafeBoundary from './components/SafeBoundary';
import { AuthProvider, useAuth } from './lib/auth';
import { supabase } from './lib/supabase';

function NoAccessScreen({ user }) {
  const { t } = useTranslation();
  async function signOut() {
    await supabase.auth.signOut();
    window.location.reload();
  }
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 20,
    }}>
      <div style={{
        width: '100%', maxWidth: 460,
        background: 'var(--bg2)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-xl)', padding: '36px 32px',
        boxShadow: 'var(--shadow2)', textAlign: 'center',
      }}>
        <div style={{
          width: 50, height: 50, borderRadius: '50%',
          background: 'var(--amber-l)', border: '1px solid var(--amber-b)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22, marginBottom: 16,
        }}>⏳</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--t0)', marginBottom: 8, letterSpacing: '-.02em' }}>
          {t('noaccess.title')}
        </h2>
        <p style={{ fontSize: 13, color: 'var(--t1)', marginBottom: 18, lineHeight: 1.6 }}>
          {t('noaccess.body', { email: user.email })
            .split(user.email)
            .reduce((acc, part, i, arr) => {
              acc.push(<React.Fragment key={i}>{part}</React.Fragment>);
              if (i < arr.length - 1) acc.push(<strong key={`b-${i}`} style={{ color: 'var(--t0)' }}>{user.email}</strong>);
              return acc;
            }, [])}
        </p>
        <p style={{ fontSize: 11, color: 'var(--t3)', marginBottom: 20, lineHeight: 1.5 }}>
          {t('noaccess.admin_label')}
        </p>
        <button onClick={signOut} className="btn">{t('noaccess.btn_signout')}</button>
      </div>
    </div>
  );
}

function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0f1117', color: '#6b7394',
      fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, letterSpacing: '.02em',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 36, height: 36, background: '#3b82f6', borderRadius: 9,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 800, color: 'white', letterSpacing: '-.03em',
          marginBottom: 14, animation: 'pulse 1.4s ease-in-out infinite',
        }}>PP</div>
        <div>{t('loading')}</div>
        <style>{`@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(.9)}}`}</style>
      </div>
    </div>
  );
}

function AppGate() {
  const { session, profile, loading, user } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!session) return <Login />;
  if (profile?.no_profile) return <NoAccessScreen user={user} />;
  if (profile?.password_set === false) return <SetPassword isInitial={true} />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SafeBoundary>
      <AuthProvider>
        <AppGate />
      </AuthProvider>
    </SafeBoundary>
  </React.StrictMode>
);
